// src/components/navbar/searchBar/SearchBar.js
// Updated implementation based on user-provided code.

import React from "react";
import PropTypes from 'prop-types'; // Added PropTypes import
import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
  Icon, // Import Icon if using it directly (though SearchIcon from @chakra-ui/icons is used here)
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons"; // Import SearchIcon

export function SearchBar(props) {
  // Pass the computed styles into the `__css` prop (Note: __css is internal, prefer standard props)
  // Destructure props for easier use
  const { variant, background, children, placeholder, borderRadius, ...rest } = props;

  // Chakra Color Mode values for styling
  const searchIconColor = useColorModeValue("gray.700", "white");
  // Use background prop if provided, otherwise default based on color mode
  const inputBg = useColorModeValue("secondaryGray.300", "navy.900");
  const inputText = useColorModeValue("gray.700", "gray.100");

  // Note: This version doesn't include internal state or onChange handling like the previous one.
  // Search input value and handling would need to be managed by the parent component.

  return (
    <InputGroup w={{ base: "100%", md: "200px" }} {...rest}>
      <InputLeftElement
        // The 'children' prop for InputLeftElement is deprecated in newer Chakra UI versions.
        // It's recommended to place the element directly inside.
        // However, keeping as provided by user for now.
        children={
          <IconButton
            aria-label="Search database" // Added aria-label for accessibility
            bg='inherit'
            borderRadius='inherit'
            _hover={{ bg: 'inherit' }} // Simplified hover, setting 'none' might not be intended
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
            icon={
              // Render the SearchIcon from @chakra-ui/icons
              <SearchIcon color={searchIconColor} w='15px' h='15px' />
            }
          /> // Removed unnecessary closing tag content ></IconButton>
        }
      />
      <Input
        // Use a standard Chakra variant or a custom one defined in the theme
        variant={variant || 'outline'} // Changed 'search' to 'outline' as 'search' isn't standard
        fontSize='sm'
        bg={background ? background : inputBg} // Use background prop or default
        color={inputText}
        fontWeight='500'
        _placeholder={{ color: "gray.400", fontSize: "14px" }}
        // Use borderRadius prop or default
        borderRadius={borderRadius ? borderRadius : "30px"}
        // Use placeholder prop or default
        placeholder={placeholder ? placeholder : "Search..."}
        // Added focus styles for better usability
         _focus={{
            borderColor: useColorModeValue('blue.300', 'blue.200'),
            boxShadow: `0 0 0 1px ${useColorModeValue('blue.300', 'blue.200')}`
        }}
      />
      {/* Render children if any are passed */}
      {children}
    </InputGroup>
  );
}

// Added PropTypes definition
SearchBar.propTypes = {
    variant: PropTypes.string,
    background: PropTypes.string,
    children: PropTypes.node,
    placeholder: PropTypes.string,
    borderRadius: PropTypes.string,
    // Add props for search handling if needed (e.g., value, onChange)
    // value: PropTypes.string,
    // onChange: PropTypes.func,
};


// Export as default if preferred
// export default SearchBar;
